import React, { useContext, useEffect, useState } from "react";
import { Container, Table, Button, Row, Col, Input, FormGroup, Label } from "reactstrap";
import Header from "../../components/Headers/Header";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import useHistory, { HistoryType } from "../../context/hooks/useHistory";
import { EmpresasContext } from "../../context/EmpresasContext";
import ModalHistory from "../../components/ModalHistory/ModalHistory";

const PresentationHistory = () => {
    const { getAllHistoriesPaged, historiesList, getPresentationByNetwork, getPresentationHtmlByNetwork, pageCount } = useHistory();
    const { getAllNetworks, listNetworks } = useContext(EmpresasContext);

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataSearch, setDataSearch] = useState({ network: "" });
    const [modalOpen, setModalOpen] = useState(false);
    const [htmlContent, setHtmlContent] = useState("");

    useEffect(() => {
        async function fetchInitialData() {
            setLoading(true);
            try {
                await getAllNetworks();
                await fetchHistories(1);
            } catch (error) {
                console.error("Erro ao carregar dados iniciais:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchInitialData();
    }, []);

    const fetchHistories = async (pageNumber: number) => {
        setLoading(true);
        try {
            await getAllHistoriesPaged(pageNumber, dataSearch.network);
        } catch (error) {
            console.error("Erro ao buscar históricos:", error);
        } finally {
            setLoading(false);
        }
    };

    const onChangePaginationCommon = async (e: any, value: any) => {
        setCurrentPage(value);
        await fetchHistories(value);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setDataSearch({ ...dataSearch, network: e.target.value });
    };

    const handleSearchSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setCurrentPage(1);
        await fetchHistories(1);
    };

    const handleDownload = async (id: number) => {
        const base64Data = await getPresentationByNetwork(id);
        if (base64Data) {
            const fileName = "presentation.pdf";
            const linkSource = base64Data;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    };

    const handlePresent = async (id: number) => {
        setLoading(true);
        try {
            const htmlContent = await getPresentationHtmlByNetwork(id); 
            if (htmlContent) {
                setHtmlContent(htmlContent); 
                setModalOpen(true); 
            }
        } catch (error) {
            console.error("Erro ao carregar a apresentação HTML:", error);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <>
            {loading && <LoadingSpinner />}
            <Header />
            <AdminNavbar brandText={"Histórico de relatórios"} search={false} titleSearch={""} />
            <Container className="mt-4">
                <Row>
                    <Col xs="6">
                        <form className="d-flex align-items-center" onSubmit={handleSearchSubmit}>
                            <FormGroup className="me-3 mb-0" style={{ flex: "1" }}>
                                <Label for="network">Rede</Label>
                                <select
                                    className="form-control form-control-alternative"
                                    name="network"
                                    id="network"
                                    value={dataSearch.network}
                                    onChange={(e) => setDataSearch({ ...dataSearch, network: e.target.value })}
                                >
                                    <option value="">Selecione uma Rede</option>
                                    {listNetworks.map((network, index) => (
                                        <option key={index} value={network.name}>
                                            {network.name}
                                        </option>
                                    ))}
                                </select>
                            </FormGroup>

                            <Button
                                style={{ color: "#FFF", backgroundColor: "#2c2c2c", top: "15px" }}
                                type="submit"
                                size="m"
                            >
                                Buscar
                            </Button>
                        </form>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col>
                        <div className="table-responsive">
                            <Table style={{ tableLayout: "fixed", width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>Rede</th>
                                        <th>Data de Criação</th>
                                        <th>Tipo de arquivo</th>
                                        <th>Visualizado</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historiesList.map((histories, index) => (
                                        <tr key={index}>
                                            <td>{histories.network}</td>
                                            <td>{histories.createdData}</td>
                                            <td>
                                                {histories.historyType === 0 || histories.historyType === null ? 'Consolidação' : 'Apresentação'}
                                            </td>

                                            <td>
                                                {histories.viewingDate
                                                    ? `Visualizado em: ${histories.viewingDate}`
                                                    : "Não visualizado"}
                                            </td>
                                            <td>
                                                {histories.historyType === 0 || histories.historyType === null ? (
                                                    <Button
                                                        onClick={() => handleDownload(histories.id)}
                                                        style={{ color: "#FFF", backgroundColor: "#2c2c2c" }}
                                                    >
                                                        Baixar
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        onClick={() => handlePresent(histories.id)}
                                                        style={{ color: "#FFF", backgroundColor: "#007bff" }}
                                                    >
                                                        Apresentar
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            {pageCount && (
                                <PaginationMaterial
                                    onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                    key={pageCount}
                                    count={pageCount}
                                />
                            )}
                            {historiesList.length === 0 && (
                                <div style={{ color: "red" }}>NENHUM REGISTRO ENCONTRADO</div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
            <ModalHistory
                open={modalOpen}
                handleClose={() => setModalOpen(false)}
                htmlContent={htmlContent}
            />
        </>
    );
};

export default PresentationHistory;